/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Project_Rag_Override_Set_Desc_UnnamedInputs */



/**
* | output |
* | --- |
* | "The internal-only override for this project was updated." |
*
* @param {Audit_Details_Project_Rag_Override_Set_Desc_UnnamedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_project_rag_override_set_desc_unnamed = /** @type {((inputs?: Audit_Details_Project_Rag_Override_Set_Desc_UnnamedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Project_Rag_Override_Set_Desc_UnnamedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Nur-interne-Quellen-Override für dieses Projekt wurde aktualisiert.")
	return /** @type {LocalizedString} */ ("The internal-only override for this project was updated.")
});